import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalStorageService } from '../services/local-storage/local-storage.service';

/**
 * AUTH GUARD
 * Protects routes from unauthorized access
 * Checks if user is authenticated before allowing route activation
 */
export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const store = inject(LocalStorageService);

  const isAuthenticated = !!store.getToken();

  if (!isAuthenticated) {
    router.navigate(['/auth/login'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }

  return true;
};
